import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function UpdateAgenciesUserActivityeService(token,data) {
    return axios.post(`${CURRENT_API_URL}/account/updateAgenciesUserActivity`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        return res.data; // Correctly return the response data
    }).catch(error => {
        console.error(error);
        notify.NotifyError("An error occurred while updating account details. Please try again later.");
        return false;
    });
}

export  default UpdateAgenciesUserActivityeService